module.exports = __webpack_public_path__ + "media/flags/bh-d0436d0b.svg";